<template>
    <div>
        <!-- DIALOG PARA REESTABLECER CONTRASEÑA -->
        <v-dialog v-model="mostrarPass" persistent max-width="310">
            <v-card>
                <v-card-title class="headline">Zona protegida</v-card-title>
                <v-card-text>
                    <p>Esta acción requiere ingresar su contraseña.</p>
                    <v-text-field label="Contraseña" name="resetPassTF" v-model="pass" type="password"></v-text-field>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="$emit('cerrar')">Cancelar</v-btn>
                <v-btn color="primary" @click="resetPassAction()">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- DIALOG PARA MOSTRAR EL NUEVO PASS -->
        <v-dialog v-model="confirm" persistent max-width="310">
            <v-card>
                <v-card-title class="headline">Contraseña reestablecida</v-card-title>
                <v-card-text>
                    <p>Nueva contraseña:</p>
                    <h2>{{newPass}}</h2>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="$emit('cerrar')">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from '../../components/Loader'
import axios from 'axios'

export default {
    name: 'ResetPass',
    props:['id','mostrar'],
	components: {
        Loader,
	},
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId"
        ])
    },
    data() {
        return {
            mostrarPass: null,
            pass: null,
            confirm: null,
            newPass: null
        }
    },
    created(){
        this.mostrarPass = this.mostrar;
    },
    methods:{
        resetPassAction(){
            this.$emit('enviandoStart');
            axios.put(this.httpURL+'/personal/resetPassword/'+this.id,
                { password: this.pass},
                {headers:{token: this.sessionToken}})
                .then(res => {
                    this.$emit('enviandoStop');
                    this.mostrarPass = false;
                    this.newPass = res.data.pass;
                    this.confirm = true;
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.$emit('enviandoStop');
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        }
    }
}
</script>